module.exports = __webpack_public_path__ + "media/icons/player4-75848394.png";